import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    sports: [],
    loading: false,
    error: null,
};

const sportSlice = createSlice({
    name: 'sport',
    initialState,
    reducers: {
        setSports: (state, action) => {
            state.sports = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        addSport: (state, action) => {
            state.sports.unshift(action.payload);
        },
        updateSport: (state, action) => {
            const index = state.sports.findIndex((s) => s.id === action.payload.id);
            if (index !== -1) {
                state.sports[index] = action.payload;
            }
        },
        removeSport: (state, action) => {
            state.sports = state.sports.filter((s) => s.id !== action.payload);
        },
        clearError: (state) => {
            state.error = null;
        },
    },
});

export const { setSports, setLoading, setError, addSport, updateSport, removeSport, clearError } =
    sportSlice.actions;

export default sportSlice.reducer;
